import { render, staticRenderFns } from "./AdsPlaceTabLinks.vue?vue&type=template&id=9317612e"
import script from "./AdsPlaceTabLinks.vue?vue&type=script&lang=js"
export * from "./AdsPlaceTabLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports